document.onreadystatechange = function () {
  if (document.readyState == 'complete') {
    const removeCheckoutButton = document.querySelector('a[href="/checkout"].btn.btn-primary.btn-lg.display-in-b.margin-top-10.petty-go-to-checkout.full-width.rale-checkout--invisible');
    removeCheckoutButton.remove();
  }
}

